export enum TipoProducto {
    Indeterminado = 0,
    Aerocombustible = 1,
    Aeroespecialidad = 2,
    Combustible = 3,
    Servicios = 4,
    }
